import { Link } from "react-router-dom";
import { ArrowRight, Receipt, ShieldCheck, Wrench, Zap } from "lucide-react";

const FEATURES = [
  { icon: Receipt, title: "Transparent Rent & Deposit", description: "No hidden maintenance fees or surprise charges." },
  { icon: Wrench, title: "Instant Maintenance Requests", description: "Submit issues directly to property managers in seconds." },
  { icon: Zap, title: "Digital Electricity & Bill Split", description: "Clear automated breakdown of monthly utility bills." },
  { icon: ShieldCheck, title: "Real-Time Occupancy Verification", description: "Know room availability live before booking." },
];

export function FeaturesSection() {
  return (
    <section className="py-16 sm:py-24" data-testid="features-section">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 md:px-10">
        <div className="text-xs uppercase tracking-[0.2em] text-blue-600 font-semibold">Why StayCare</div>
        <h2 className="font-hero text-3xl sm:text-4xl font-bold tracking-tight text-slate-900 mt-2 mb-10">Why tenants & owners choose us</h2>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {FEATURES.map(({ icon: Icon, title, description }) => (
            <div key={title} className="bg-white border border-slate-200 rounded-xl p-6 hover:shadow-md transition-shadow"
                 data-testid={`feature-${title.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}>
              <div className="h-11 w-11 rounded-lg bg-blue-50 text-blue-600 flex items-center justify-center mb-4">
                <Icon className="h-5 w-5" />
              </div>
              <div className="font-semibold text-slate-900">{title}</div>
              <div className="text-sm text-slate-500 mt-2 leading-relaxed">{description}</div>
            </div>
          ))}
        </div>
        <div className="mt-12 bg-slate-900 rounded-2xl px-6 sm:px-10 py-10 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-6">
          <div>
            <div className="font-hero text-2xl sm:text-3xl font-bold text-white tracking-tight">Found a room you like?</div>
            <div className="text-slate-400 text-sm mt-2">Fill in your details — we’ll assign you a room.</div>
          </div>
          <Link to="/register" data-testid="cta-bottom-apply"
                className="inline-flex items-center gap-3 bg-blue-600 text-white px-8 py-4 rounded-lg font-semibold hover:bg-blue-700 transition-colors whitespace-nowrap">
            Apply now <ArrowRight className="h-5 w-5" />
          </Link>
        </div>
      </div>
    </section>
  );
}
